import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { TaskService } from 'app/task/task.service';

declare const Mangler: any;

@Component({
	selector: 'ui-subtask-list',
	templateUrl: './ui-subtask-list.component.html',
	styleUrls: ['./ui-subtask-list.component.scss']
})
export class SubtaskListComponent implements OnInit {

	@Input() item;
	@Input() editable = false;
	@Output() editSubTask = new EventEmitter();
	@Output() markFollowUpSubTask = new EventEmitter();
	@Output() editedSubtaskStage = new EventEmitter();
	@Output() clickDependency = new EventEmitter();
	@Output() notesClicked = new EventEmitter();
	@Output() addDependency = new EventEmitter();

	tabs = [
		{ value: 'all', label: 'All' },
		{ value: 'finished', label: 'Finished' },
		{ value: 'pending', label: 'Pending' }
	];
	tab = 'all';
	expandedSubtask = [];

	subtasks = [];

	constructor(
		public service: TaskService,
		public app: AppService,
		public api: ApiService
	) { }

	ngOnInit(): void {
		this.subtasks = Mangler.clone(this.item.sub_tasks);
	}

	edit(item) {
		if (this.editable && !item.completed) this.editSubTask.emit(item);
	}

	markFollowUp(item) {
		if (this.editable) this.markFollowUpSubTask.emit(item);
	}

	hasCompletedDependencies(item) {
		if (!item?.dependencies) return false;

		for (let i = 0; i < item.dependencies.length; i++) {
			if (item.dependencies[i].done) return true;
		}

		return false;
	}

	onTabSelected(id) {
		this.tab = id;
		if (!this.item.group_by) {
			if (id === 'finished') {
				this.item.sub_tasks[0].sub_tasks = Mangler.clone(this.subtasks[0].sub_tasks.filter(subtask => subtask.stage === 'completed'));
			} else if (id === 'pending') {
				this.item.sub_tasks[0].sub_tasks = Mangler.clone(this.subtasks[0].sub_tasks.filter(subtask => subtask.stage !== 'completed'));
			} else {
				this.item.sub_tasks[0].sub_tasks = Mangler.clone(this.subtasks[0].sub_tasks);
			}
		}
	}

	getCompletedDependencies(dependencies: any[]): number {
		return dependencies.filter(dep => dep.done === 1).length;
	}

	toggleDependencies(item) {
		if (!this.editable) return;
		if (!this.hasCompletedDependencies(item)) return;

		item.showDependencies = !item.showDependencies;
	}

	openTaskNotes(subtask) {
		this.notesClicked.emit(subtask);
	}

	toggleSubtaskStage(subtask) {
		if (subtask.stage === 'completed') {
			this.markAsActive(subtask);
		} else {
			this.markAsCompleted(subtask);
		}
	}

	markAsCompleted(subtask) {
		this.app.dialog.pop('Mark as Complete', 'Are you sure you want to mark this sub task as Completed?', ['Cancel', '*Submit'], btn => {
			if (btn === 1) {
				this.api.task.markAsCompleted(subtask.id, () => {
					this.app.notifications.showSuccess('Sub task Completed.');
					this.editedSubtaskStage.emit(subtask);
				}, error => {
					this.app.notifications.showDanger(error.message);
				});
			}
		});
	}

	markAsActive(subtask) {
		this.app.dialog.pop('Mark as Active', 'Are you sure you want to mark this sub task as Active?', ['Cancel', '*Submit'], btn => {
			if (btn === 1) {
				this.api.task.markAsActive(subtask.id, () => {
					this.app.notifications.showSuccess('Sub task marked as Active.');
					this.editedSubtaskStage.emit(subtask);
				}, error => {
					this.app.notifications.showDanger(error.message);
				});
			}
		});
	}

	// Subtask
	setSubtaskExpanded(id, state) {
		if (state) {
			if (!Mangler.first(this.expandedSubtask, id)) this.expandedSubtask.push(id);
		} else {
			Mangler.filter(this.expandedSubtask, { $ne: id });
		}
		this.expandedSubtask = this.expandedSubtask.slice();
	}

	isSubtaskExpanded(i) {
		return !!Mangler.first(this.expandedSubtask, i);
	}

	toggleSubtaskExpanded(id) {
		this.setSubtaskExpanded(id, !this.isSubtaskExpanded(id));
	}

	getStatusCount(subtasks: any[], status): number {
		if (!subtasks || !Array.isArray(subtasks)) {
			return 0;
		}
		return subtasks.filter(subtask => subtask.stage === status).length;
	}

}
